import { render, staticRenderFns } from "./DuaMessageOk.vue?vue&type=template&id=6c53877a"
import script from "./DuaMessageOk.vue?vue&type=script&lang=js"
export * from "./DuaMessageOk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports